import dayjs, { Dayjs, ConfigType } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(localizedFormat);

export function formatDateTime(date: ConfigType, format?: string): string {
  if (!date) {
    return '';
  }
  if (format) {
    return `${dayjs(date).utc().format(format)} (UTC)`;
  } else {
    return `${dayjs(date).utc().format('YYYY-MM-DD HH:mm:ss')} (UTC)`;
  }
}

export function formatWrittenDate(date: ConfigType): string {
  return dayjs(date).format('MMM DD, YYYY');
}

export const getMomentUTC = (date: ConfigType): Dayjs | undefined => (date ? dayjs(date).utc() : undefined);

export function formatRelativeTime(date: ConfigType): string {
  if (!date) {
    return '';
  }
  return dayjs(date).fromNow();
}

export function formatDuration(startDate: ConfigType, endDate: ConfigType): string {
  if (!startDate || !endDate) {
    return '';
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const durationObj = dayjs.duration(end.diff(start));

  const days = Math.floor(durationObj.asDays());
  const hours = durationObj.hours();
  const minutes = durationObj.minutes();
  const seconds = durationObj.seconds();

  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days} day${days !== 1 ? 's' : ''}`);
  }
  if (hours > 0) {
    parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);
  }
  if (seconds > 0 && days === 0 && hours === 0) {
    // Only show seconds if duration is less than an hour
    parts.push(`${seconds} second${seconds !== 1 ? 's' : ''}`);
  }

  return parts.length > 0 ? parts.join(' ') : '0 seconds';
}
